import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/system/interface/config/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/system/interface/config/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/system/interface/config/updateById', data)
}

// 修改状态
export function updateStatus (data) {
  return request.post('/system/interface/config/updateStatus', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/system/interface/config/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/system/interface/config/delete/batch', {
    params: {
      ids
    }
  })
}
